// @ts-nocheck
/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import SearchAndSelect from '../../../../../common/components/core/SearchAndSelect/SearchAndSelect';

import { fetchGeoTargetingShapes } from '../../../../actions/DiscoAdsActions';
import { getGeoTargetingOptions, isPageLoading } from '../../selectors/pageStateSelectors';
import { DA_CREATOR_FORM_SECTION_COPY } from '../../discoAdsConstants';
import type { Dispatch, RootState } from 'client/js/redux';

const GEO_OPTION_SECONDARY_LABEL_KEY = 'type';
const GEO_SELECTION_STATUS_LABEL_TYPE = 'default';

class GeoTargetMultiSelect extends Component {
  state = {
    geoQuery: '',
  };

  _handleFetchGeoTargetingShapes = () => {
    const { geoQuery } = this.state;
    this.props.fetchGeoTargetingShapes({ userQuery: geoQuery });
  };

  _onGeoSearchQueryChange = (userQuery, { action }) => {
    if (action === 'input-change') {
      this.setState(
        {
          geoQuery: userQuery,
        },
        this._handleFetchGeoTargetingShapes
      );
    }
  };

  render() {
    const {
      geoTargetingOptions,
      dropdownIsLoading,
      selectedGeoTargets,
      onSelectedGeoTargetsChange,
      onRemoveGeoTargetFromSelected,
      onRemoveAllGeoTargetsFromSelected,
    } = this.props;
    const {
      campaign: { geoTargets: geoTargetsCopy },
    } = DA_CREATOR_FORM_SECTION_COPY;
    return (
      <SearchAndSelect
        testid="dac-geo-targeting"
        inputValue={this.state.geoQuery}
        options={geoTargetingOptions}
        onInputChange={this._onGeoSearchQueryChange}
        onChange={onSelectedGeoTargetsChange}
        value={selectedGeoTargets}
        onRemoveSelection={onRemoveGeoTargetFromSelected}
        onRemoveAllSelections={onRemoveAllGeoTargetsFromSelected}
        placeholder={geoTargetsCopy.searchPlaceholder}
        secondaryLabelKey={GEO_OPTION_SECONDARY_LABEL_KEY}
        statusLabelType={GEO_SELECTION_STATUS_LABEL_TYPE}
        isLoading={dropdownIsLoading}
      />
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  geoTargetingOptions: getGeoTargetingOptions(state),
  dropdownIsLoading: isPageLoading(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    fetchGeoTargetingShapes: ({ userQuery }) => {
      dispatch(fetchGeoTargetingShapes({ userQuery }));
    },
  };
};

const ConnectedGeoTargetMultiSelect = connect(mapStateToProps, mapDispatchToProps)(GeoTargetMultiSelect);

export default ConnectedGeoTargetMultiSelect;
